/** Display formatting. Money arrives as micros strings; never do money math in floats beyond display. */
export { formatMoney as money } from "@brecx/shared";

export function pct(v: number | null | undefined, decimals = 0): string {
  return v === null || v === undefined ? "—" : `${v.toFixed(decimals)}%`;
}

export function ratio(v: number | null | undefined, decimals = 2): string {
  return v === null || v === undefined ? "—" : v.toFixed(decimals);
}

export function num(v: number | null | undefined, decimals = 0): string {
  return v === null || v === undefined
    ? "—"
    : v.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

/** "▲ +4.2%" style delta text and tone. */
export function delta(
  v: number | null | undefined,
  opts: { points?: boolean; lowerIsBetter?: boolean } = {},
): { text: string; tone: string } | null {
  if (v === null || v === undefined || !Number.isFinite(v)) return null;
  const arrow = v > 0 ? "▲" : v < 0 ? "▼" : "■";
  const text = `${arrow} ${v > 0 ? "+" : ""}${v.toFixed(opts.points ? 2 : 1)}${opts.points ? "" : "%"}`;
  if (Math.abs(v) < 1e-9) return { text, tone: "flat" };
  const up = v > 0;
  const tone = opts.lowerIsBetter ? (up ? "up bad" : "down good") : up ? "up" : "down";
  return { text, tone };
}

export function shortDate(iso: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function ago(iso: string | null): string {
  if (!iso) return "never";
  const mins = Math.round((Date.now() - Date.parse(iso)) / 60_000);
  if (mins < 1) return "just now";
  if (mins < 90) return `${mins} min ago`;
  if (mins < 48 * 60) return `${Math.round(mins / 60)} h ago`;
  return `${Math.round(mins / 1440)} d ago`;
}
